import { useEffect } from 'react';
import { useAppSelector } from '.';
import { selectIsRequestStart } from '@/redux/selectors/signalRSelectors';
import { useAuth } from 'react-oidc-context';

export const useSignalR = () => {
  const auth = useAuth();
  const requestStart = useAppSelector(selectIsRequestStart);

  useEffect(() => {
    if (auth.isAuthenticated && requestStart) {
      import('@/lib/signalR').then(({ startSignalR }) => {
        startSignalR();
      });
    }
  }, [auth.isAuthenticated, requestStart]);
};
